(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.image-gallery').forEach(function(gallery) {
    const slides = gallery.querySelectorAll('.image-gallery__slide');
    const thumbs = gallery.querySelectorAll('.image-gallery__thumb');
    const dots = gallery.querySelectorAll('.image-gallery__dot');
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    let currentIndex = 0;

    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      
      slides.forEach(function(slide, i) {
        slide.classList.toggle('active', i === index);
      });
      thumbs.forEach(function(thumb, i) {
        thumb.classList.toggle('active', i === index);
      });
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === index);
      });
      
      currentIndex = index;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goToSlide(currentIndex + 1);
      });
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.thumbIndex));
      });
    });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.dotIndex));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-hero__quantity').forEach(function(container) {
    var input = container.querySelector('.product-hero__quantity-input');
    var buttons = container.querySelectorAll('.product-hero__quantity-btn');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var action = this.dataset.action || (this.textContent.trim() === '-' ? 'decrease' : 'increase');
        var value = parseInt(input.value) || 1;
        if (action === 'decrease' && value > 1) { input.value = value - 1; }
        else if (action === 'increase') { input.value = value + 1; }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          document.dispatchEvent(new CustomEvent("hb:scan"));
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
